module.exports = __webpack_public_path__ + "static/media/news5-1.395c6efc.jpg";